import Typography from "antd/lib/typography";
import clsx from "clsx";
import { ReactNode, cloneElement, isValidElement } from "react";

type HomeCardProps = {
    className?: string;
    title?: ReactNode;
    image?: ReactNode;
    children: ReactNode;
    action?: ReactNode;
};
export function HomeCard({ className, title, children, image, action }: HomeCardProps) {
    const hasImage = !!image;

    return (
        <section
            className={clsx(
                "rounded-ant-lg border-ant border-ant-secondary bg-ant-container p-ant md:p-ant-md",
                "flex flex-col gap-ant",
                className,
            )}
        >
            {(title || action) && (
                <div className="flex w-full items-center gap-4 max-sm:flex-col md:justify-between">
                    {title && (
                        <h2 className="mb-0! font-ant text-ant-h3 leading-ant-h3 font-ant-strong text-color-ant-primary!">
                            {title}
                        </h2>
                    )}
                    {action ? action : null}
                </div>
            )}
            <div className={clsx("flex flex-1 items-center gap-4 max-md:flex-col lg:gap-8")}>
                {hasImage && isValidElement(image) ? (
                    <>
                        {cloneElement(image, {
                            className: clsx("size-[100px] max-xl:size-20 max-md:size-16", image.props.className),
                        } as any)}
                    </>
                ) : null}
                {children}
            </div>
        </section>
    );
}

type HomeCardDescriptionProps = {
    className?: string;
    label?: string;
    children?: ReactNode;
};

export function HomeCardDescription({ label, children, className }: HomeCardDescriptionProps) {
    return (
        <div className={clsx("w-full  max-sm:text-center", className)}>
            {label ? <h2 className="font-ant text-ant-h4 leading-ant-h4 font-ant-strong">{label}</h2> : null}
            {children ? <Typography.Paragraph className="whitespace-pre-wrap">{children}</Typography.Paragraph> : null}
        </div>
    );
}
